import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { ImbpService } from "@/services/ImbpService"
import { ImbpAvailableSlots } from "@/models/imbpAvailableSlots/imbpAvailableSlots"
import { getImbpAccount } from "./getImbpAccount"
import { AccountService } from "@/services/AccountService"
import { QueryResult } from "@/api/utils/types"
import { AuthService } from "@/services/AuthService"

export const getImbpAvailability = (
  accountNumber: string,
  includeCoreId?: boolean,
) => {
  const queries = new QueryAggregator()
  let coreIdQuery: QueryResult<number | null> | null = null

  const imbpAccountQuery = getImbpAccount(accountNumber)
  queries.add(imbpAccountQuery)

  if (includeCoreId) {
    coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
    queries.add(coreIdQuery)
  }

  const eligibilityQuery = ImbpService.getSmartMeterEligibility(accountNumber)
  queries.add(eligibilityQuery)

  const imbpAvailableSlotsQuery = ImbpService.getAvailableSlots(
    imbpAccountQuery?.data?.formattedPostcode,
    coreIdQuery?.data?.toString(),
    AuthService.getCurrentUser()?.username?.toString(),
    eligibilityQuery?.data?.meterOperatorCode ?? undefined,
    imbpAccountQuery?.data?.mprn,
    imbpAccountQuery?.data?.mpan,
    eligibilityQuery?.data?.meterInstallationType ?? undefined,
  )

  queries.add(imbpAvailableSlotsQuery)

  const data: ImbpAvailableSlots = imbpAvailableSlotsQuery.data

  return queries.setData(data).getAggregate()
}
